var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "list"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H3.01C3.42421 5.25 3.76 5.58579 3.76 6C3.76 6.41421 3.42421 6.75 3.01 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6ZM7.25002 6C7.25002 5.58579 7.5858 5.25 8.00002 5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H8.00002C7.5858 6.75 7.25002 6.41421 7.25002 6ZM2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H3.01C3.42421 11.25 3.76 11.5858 3.76 12C3.76 12.4142 3.42421 12.75 3.01 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12ZM7.25002 12C7.25002 11.5858 7.5858 11.25 8.00002 11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H8.00002C7.5858 12.75 7.25002 12.4142 7.25002 12ZM2.25 18C2.25 17.5858 2.58579 17.25 3 17.25H3.01C3.42421 17.25 3.76 17.5858 3.76 18C3.76 18.4142 3.42421 18.75 3.01 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18ZM7.25002 18C7.25002 17.5858 7.5858 17.25 8.00002 17.25H21C21.4142 17.25 21.75 17.5858 21.75 18C21.75 18.4142 21.4142 18.75 21 18.75H8.00002C7.5858 18.75 7.25002 18.4142 7.25002 18Z",
  fill: "#00538F"
}));

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.bb41f8d0.svg";
export { ForwardRef as ReactComponent };